(function () {
  'use strict';

  angular.module('ringbaPortal').component('offer', {
    bindings: {
      campaignId: '<',
      campaignCountry: '<',
      showCampaignTab: '&',
      setOfferForStatus: '&',
      affiliateNotPartOfOffer: '&',
      onOfferExpire: '&',
      reloadCampaign: '&'
    },
    controller: OfferController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/offer/offer.view.html'
  });

  function OfferController(
    $stateParams,
    $timeout,
    accountsService,
    offersService,
    userSettingsService,
    utils
  ) {
    'ngInject';

    const vm = this;

    const draftBoxId = 'campaign-offer-draft';

    vm.campaignOfferStatus = '';
    vm.showCreateOfferBox = false;
    vm.showOfferIntro = true;
    vm.draftForm = { // Flag to show editable form of draft or the summary of draft
      edit: false
    };

    vm.$onChanges = onChanges;
    vm.onCampaignOfferChange = onCampaignOfferChange;
    vm.editPublishedOffer = editPublishedOffer;
    vm.hideOfferIntro = hideOfferIntro;
    vm.hideForeverOfferIntro = hideForeverOfferIntro;
    vm.hideOfferNextStepPanel = hideOfferNextStepPanel;
    vm.focusDraftForm = focusDraftForm;
    vm.onDraftEditCancelled = onDraftEditCancelled;
    vm.handleOfferExpire = handleOfferExpire;

    function onChanges(changesObj) {
      vm.isAffiliate = vm.isAffiliate == null ? accountsService.isAffiliate() : vm.isAffiliate;

      if (changesObj.campaignId && vm.campaignId) {
        _loadCampaignOffers(vm.campaignId);
        _checkNextStepsToBeShown(vm.campaignId);
        _checkOfferIntroToBeShown();
      }
    }

    function onCampaignOfferChange() {
      _loadCampaignOffers(vm.campaignId);
      _checkNextStepsToBeShown(vm.campaignId);
    }

    function editPublishedOffer(publishedOffer) {
      vm.showDraftBox = true;
      focusDraftForm();
      vm.draftForm.edit = true;
      vm.draftOfferIsNew = false;
      if (!vm.campaignOffers.draft || !vm.draftOffer) {
        vm.draftOffer = angular.copy(publishedOffer);
        vm.draftOfferIsNew = true;
      }
      utils.scrollToElementId(draftBoxId, 50);
    }

    function onDraftEditCancelled(){
      if(vm.draftOfferIsNew)
      {
        vm.draftOfferIsNew = false;
        vm.showDraftBox = false;
        vm.draftOffer = null;
      }
    }

    function hideOfferIntro() {
      vm.showOfferIntro = false;
      userSettingsService.getUserSettings().then(function (userSettings) {
        userSettings.hideOfferIntroForCampaign = userSettings.hideOfferIntroForCampaign || {};
        userSettings.hideOfferIntroForCampaign[vm.campaignId] = true;
        return userSettingsService.saveUserSettings(userSettings);
      });
    }

    function hideForeverOfferIntro() {
      vm.showOfferIntro = false;
      userSettingsService.getUserSettings().then(function (userSettings) {
        userSettings.neverShowOfferIntro = true;
        return userSettingsService.saveUserSettings(userSettings);
      });
    }

    function hideOfferNextStepPanel() {
      vm.showOfferNextSteps = false;
    }

    function focusDraftForm() {
      // Remove and then add focus
      $timeout(function () {
        vm.focusForm = false;
        $timeout(function () {
          vm.focusForm = true;
        }, 0);
      }, 0);
    }

    function _checkOfferIntroToBeShown() {
      userSettingsService.getUserSettings().then(function (userSettings) {
        vm.showOfferIntro = !userSettings.neverShowOfferIntro && !(userSettings.hideOfferIntroForCampaign && userSettings.hideOfferIntroForCampaign[vm.campaignId]);
      });
    }

    function handleOfferExpire() {
      vm.campaignOffers.published.offerState = 'expired';
      vm.onOfferExpire();
    }

    function _checkNextStepsToBeShown(campaignId) {
      userSettingsService.getUserSettings().then(function (userSettings) {
        vm.userSettings = userSettings;
        vm.showOfferNextSteps = !userSettings.neverShowOfferNextSteps && _checkNextStepsForCampaign(userSettings, campaignId);
        vm.scrollToOfferRequests = $stateParams.showRequests;
      });
    }

    function _checkNextStepsForCampaign(userSettings, campaignId) {
      return !userSettings.offerNextSteps || typeof userSettings.offerNextSteps[campaignId] === 'undefined' || userSettings.offerNextSteps[campaignId];
    }

    function _loadCampaignOffers(campaignId) {
      if (!vm.isAffiliate) {
        _loadOfferDetailsForAdmin(campaignId);
      } else {
        _loadOfferDetailsForPublisher(campaignId).catch(vm.affiliateNotPartOfOffer);
      }
    }

    function _loadOfferDetailsForAdmin(campaignId) {
      offersService.getCampaignOffers(accountsService.currentAccountId, campaignId).then(function (response) {
        vm.campaignOffers = response.data.offers;

        vm.showCreateOfferBox = _getShowCreateOfferBox(vm.campaignOffers);
        vm.showDraftBox = vm.campaignOffers && !!vm.campaignOffers.draft;
        vm.showPublishedBox = vm.campaignOffers && !!vm.campaignOffers.published;
        vm.showOfferNextSteps = vm.showPublishedBox && (typeof vm.showOfferNextSteps === 'boolean' && vm.showOfferNextSteps || typeof vm.showOfferNextSteps !== 'boolean');
        vm.draftOffer = vm.campaignOffers && vm.campaignOffers.draft;

        const publishedOffer = vm.campaignOffers && vm.campaignOffers.published;
        vm.setOfferForStatus({ offer: publishedOffer });
      });
    }

    function _loadOfferDetailsForPublisher(campaignId) {
      return offersService.getCampaignOfferDetails(accountsService.currentAccountId, campaignId).then(function(response) {
        vm.campaignOffers = {
          published: response.data.offer
        };

        vm.showCreateOfferBox = false;
        vm.showPublishedBox = true;
        const publishedOffer = vm.campaignOffers && vm.campaignOffers.published;
        vm.setOfferForStatus({ offer: publishedOffer });
      });
    }

    function _getShowCreateOfferBox(offers) {
      if (!offers || (!offers.published && !offers.draft)) {
        return true;
      }
      return false;
    }

  }
})();
